import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';

export type SdkStatus = 'SUCCESS' | 'FAILURE';
export interface SdkMessage {
  status: SdkStatus;
  message: string;
}

@Component({
  selector: 'app-sdk-result',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  template: `
    <div class="sdk-result">
      <div class="content">
        <!-- <div class="icon" aria-hidden="true">
          <mat-icon *ngIf="status === 'SUCCESS'" class="success-icon">check_circle</mat-icon>
          <mat-icon *ngIf="status === 'FAILURE'" class="failure-icon">cancel</mat-icon>
        </div>
        <h1 class="title">{{ status === 'SUCCESS' ? 'Success' : 'Failure' }}</h1>
        <p class="message">{{ message }}</p> -->
        <h4 class="redirect-title">Redirecting...</h4>
        <!-- <button mat-raised-button color="primary" (click)="goBack()">Close</button> -->
      </div>
    </div>
  `,
  styles: [`
    .sdk-result { 
      min-height: 100vh;
      background: transparent;
      padding: 24px;
    }

    .sdk-result .content {
      text-align: left;
      max-width: none;
    }

    .sdk-result .redirect-title {
      font-size: 28px;
      margin: 0;
      color: #333;
    }

    /* Commented out styles for success/failure states
    .sdk-result .icon {
      margin-bottom: 12px;
    }

    .sdk-result .success-icon { color: #4caf50; font-size: 56px; width: 56px; height: 56px; }
    .sdk-result .failure-icon { color: #f44336; font-size: 56px; width: 56px; height: 56px; }

    .sdk-result .title {
      font-size: 28px;
      margin: 0 0 8px;
    }

    .sdk-result .message {
      opacity: 0.9;
      margin: 0 0 24px;
    }

    .sdk-result .redirect-message {
      opacity: 0.7;
      font-size: 14px;
      color: #666;
      margin: 0;
    }
    */

    button[mat-raised-button] { margin-top: 8px; }
  `]
})
export class SdkResultComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  status: SdkStatus = 'SUCCESS';
  message = '';

  ngOnInit(): void {
    // Prefer navigation state; fallback to history.state; last resort: query params
    const navState = (this.router.getCurrentNavigation()?.extras.state as { sdkMessage?: SdkMessage } | undefined)?.sdkMessage;
    const histState = (window.history?.state as { sdkMessage?: SdkMessage } | undefined)?.sdkMessage;

    const payload: SdkMessage | undefined = navState || histState;

    if (payload) {
      this.status = payload.status;
      this.message = payload.message;
    } else {
      // Fallback only for robustness (primary channel is state, not query)
      const qp = this.route.snapshot.queryParamMap;
      const status = qp.get('status')?.toUpperCase() as SdkStatus | null;
      const msg = qp.get('message');
      if (status && msg) {
        this.status = status;
        this.message = msg;
      } else {
        // No data provided; set a safe default
        this.status = 'FAILURE';
        this.message = 'No result information was provided.';
      }
    }
  }

  goBack(): void {
    // If opened in a separate window/webview, try to close; otherwise navigate home
    if (window.opener) {
      window.close();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}
